import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

const Accounts = React.lazy(() => import('./index'));
const AccountTable = React.lazy(() => import('./accountTable'));
const Account = React.lazy(() => import('./account'));
const AccountDetail = React.lazy(() => import('./accountDetail'));
const AddNewAccount = React.lazy(() => import('./addNewAccount'));

export const useAccountRoutes = () => {

    return (
        <Route path="accounts" element={<Suspense fallback={<div>منتظر باشید...</div>}><Accounts /></Suspense>} >
            <Route index element={<Suspense fallback={<div>منتظر باشید...</div>}><AccountTable /></Suspense>} />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewAccount /></Suspense>} />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Account /></Suspense>} >
                <Route index element={<Suspense fallback={<div>منتظر باشید...</div>}><AccountDetail /></Suspense>} />
            </Route>
        </Route>
    )
}